module.exports = __webpack_public_path__ + "static/media/SaveW.d9383f4d.svg";